/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import SqaureLoader from '../../../components/Loader/SqaureLoader'
import { getRapportSuiviPointagePauseDebImage } from '../../../services/Rapports/RapportsApi'

export default function ModalDebutPause({date, user_code, pdv_code,setok4,t}) {
    const [data, setdata] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getRapportSuiviPointagePauseDebImage(date, user_code)
            .then((result) => {
                if (result?.data?.success === 1) {
                    setdata(result?.data?.liste[0])
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                setLoading(false)
            })
    }, [])
  return (
    <div className="modal fade" id="debutPause" data-backdrop="static" data-keyboard="false" tabIndex={-1} role="dialog" aria-hidden="true" >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="example-Modal3"> Début pause   </h5>
                        <span ><i className='icon icon-close text-azure' style={{ cursor: "pointer" }} data-dismiss="modal" aria-label="Close" onClick={() => setok4(false)}  /> </span>

                    </div>
                    {loading ? <SqaureLoader /> : (
                        <>
                            <div className="modal-body">
                                <img src={data?.path === null || data?.path === undefined ? "../assets/images/users/17.jpg" : data?.path} alt="image_pointage" />
                            </div>
                            <div className='modal-footer'>
                                <button type="button" className="btn btn-yellow" data-dismiss="modal" aria-label="Close" onClick={() => setok4(false)} >
                                    <i className=' ti-close mr-1' /> {t('dashboard.Fermer')}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
